import React from 'react'

const Loading = () => {
  return (
    <h1 style={{textAlign: "center", margin:"auto"}}>Loding...</h1>
  )
}

export default Loading